module.exports = __webpack_public_path__ + "media/logo/logo_pamlocalmedia-62272d78.png";